import { d as debounce_1 } from "common/chunk_debounce";

class ResizeAdapter {
  config = {
    debounce: true,
    debounceInterval: 250,
  };
  onResize = () => {};
  constructor(setValue) {
    this.setValue = () => setValue(window);
  }
  connect() {
    requestAnimationFrame(this.onResize);
  }
  disconnect() {
    window.removeEventListener("resize", this.onResize);
  }
  update(config) {
    this.config = {
      ...this.config,
      ...config,
    };
    window.removeEventListener("resize", this.onResize);
    this.onResize = this.config.debounce
      ? debounce_1(() => this.setValue(), this.config.debounceInterval)
      : () => this.setValue();
    window.addEventListener("resize", this.onResize);
  }
}

export { ResizeAdapter };
